import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getLinkCustomerHostifyUrl } from "./api-url.constants";
import { LinkCustomerHostifyError } from "./errors";

interface LinkCustomerHostifyBody {
  apiKey: string;
  userId?: string;
}

export const linkCustomerHostify = async (body: LinkCustomerHostifyBody): Promise<void> => {
  const response = await typedFetch(getLinkCustomerHostifyUrl(body.userId), {
    method: API_METHODS.POST,
    body: JSON.stringify({
      apiKey: body.apiKey,
    }),
  });

  if (!response.ok) throw new LinkCustomerHostifyError();
};
